import {
  defineStore
} from 'pinia'
import {
  ref
} from 'vue'

export const useUserStore = defineStore('user', () => {
  const token = ref(null)
  const user = ref(null)
  const username = ref(null)
  const avatar = ref(null)
  const roles = ref(null)
  const permissions = ref(null)
  const isLoggedIn = ref(false)

  function login(userData, tokenData) {
    user.value = userData
    token.value = tokenData
    username.value = userData.username
    avatar.value = userData.avatar
    if (userData.roleEntities) {
      roles.value = userData.roleEntities.map(r => r.name)
    }
    if (userData.permissionEntities) {
      permissions.value = userData.permissionEntities.map(r => r.name)
    }
    isLoggedIn.value = true
  }

  function logout() {
    token.value = null
    user.value = null
    username.value = ''
    avatar.value = ''
    roles.value = []
    permissions.value = []
    isLoggedIn.value = false
  }

  return {
    token,
    user,
    username,
    avatar,
    roles,
    permissions,
    isLoggedIn,
    login,
    logout
  }
})